module.exports = __webpack_public_path__ + "img/jl.09223cea.jpg";